import { render, staticRenderFns } from "./scroll-bar.vue?vue&type=template&id=2f3d1788"
import script from "./scroll-bar.vue?vue&type=script&lang=js"
export * from "./scroll-bar.vue?vue&type=script&lang=js"
import style0 from "./scroll-bar.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/components/scroll-bar/vue-scroller-bars/scroll-bar.vue
// module id = null
// module chunks = 